import { gql } from '@apollo/client';
import { QUESTIONNAIRE_TEMPLATE_FRAGMENT } from '../fragments/questionnaireTemplates';

export const GET_QUESTIONNAIRE_TEMPLATES = gql`
  query GetQuestionnaireTemplates {
    questionnaireTemplates {
      edges {
        node {
          ...QuestionnaireTemplateFragment
        }
      }
    }
  }
  ${QUESTIONNAIRE_TEMPLATE_FRAGMENT}
`;
